import React from 'react'
import { Row, Col } from 'react-bootstrap'
import ExportableComponent from '../export/ExportableComponent';

import '../../../assets/sass/components/sections/receipt.scss'

class Receipt extends ExportableComponent {

    renderContent = () => {
        const {exportOnly} = this.props;

        return exportOnly ? this.renderPdf() : this.renderReceipt();
    }

    renderPdf = () => {
        return (
            <div className="theme--default">
                {this.renderReceipt()}
            </div>
        )
    }

    renderReceipt = () => {
        const {
            company,
            date,
            address,
            orderId,
            orderDate,
            planType,
            amount,
            tax,
            fees,
            buyer
        } = this.props;

        return (
            <div className="receipt">
                <div className="header">
                    <h4 className="title md">Purchase Receipt</h4>
                    <span className="label">Generated on {date}</span>
                </div>
                <div className="main-info">
                    <h3 className="title lg">{company}</h3>
                    <Row>
                        <Col md={6}>
                            <p className="text">{address}</p>
                        </Col>
                        <Col md={6}>
                            <div className="item">
                                <span className="label">Order ID</span>
                                <span className="text">{orderId}</span>
                            </div>
                        </Col>
                    </Row>
                </div>
                <div className="main-info">
                    <h6 className="label">Sold To</h6>
                    <h3 className="title md">{company}</h3>
                    <span className="text">{buyer.email}</span>
                </div>
                <div className="main-info">
                    <Row>
                        <Col md={4}>
                            <h6 className="label">Plan Type</h6>
                            <h3 className="title md">{planType} Membership</h3>
                        </Col>
                        <Col md={4}>
                            <h6 className="label">Order Date</h6>
                            <h3 className="title md">{orderDate}</h3>
                        </Col>
                        <Col md={4}>
                            <h6 className="label">Amount</h6>
                            <h3 className="title md">${amount}</h3>
                        </Col>
                    </Row>
                </div>
                <div className="main-info text-right">
                    <Row>
                        <Col md={{ span: 6, offset: 6 }}>
                            <Row>
                                <Col md={7}>
                                    <div className="label">Service Tax</div>
                                </Col>
                                <Col md={5}>
                                    <div className="title sm">${tax}</div>
                                </Col>
                            </Row>
                        </Col>
                        <Col md={{ span: 6, offset: 6 }}>
                            <Row>
                                <Col md={7}>
                                    <div className="label mb-0">Processing Fees</div>
                                </Col>
                                <Col md={5}>
                                    <div className="title sm mb-0">${fees}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <div className="main-info">
                    <Row>
                        <Col md={{ span: 6, offset: 6 }}>
                            <Row>
                                <Col md={7}>
                                    <div className="label mb-0">Total Paid</div>
                                </Col>
                                <Col md={5}>
                                    <div className="title sm mb-0">${amount + tax + fees}</div>
                                </Col>
                            </Row>
                        </Col>
                    </Row>
                </div>
                <footer className="generate-footer">
                    <span>This receipt is generated from <a href="http://www.scoutafrique.com">www.scoutafrique.com</a></span>
                </footer>
            </div>
        )
    }

    // render = () => this.renderContent()

    static defaultProps = {
        ref: "report",
        company: "ScoutAfrique",
        date: "12/31/2020",
        address: "817 Preston Rd undefined Oxnard, Missouri 75738 United States",
        orderId: "1234567898765",
        orderDate: '12/31/2020',
        planType: 'gold',
        amount: 49.99,
        tax: 1,
        fees: 2,
        buyer: {
            name: 'Jack Scott',
            email: 'jackscott@gmail.com'
        }
    }
}

export default Receipt
